export const getFormattedDate = (date) => {
  const year = date.getFullYear()
  const month = (1 + date.getMonth()).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  return month + '/' + day + '/' + year
}

export const getCookie = (cookieName) => {
  const cookies = document.cookie.split('; ')
  for (let cookie of cookies) {
    const [name, value] = cookie.split('=')
    if (name === cookieName) {
      return decodeURIComponent(value)
    }
  }
  return null
}

export const setCookie = (cookieName, value = null, maxAge = null, expireTime = null, path = '/') => {
  document.cookie = cookieName + '=' + (value == null ? '' : value) + '; ' + (maxAge == null ? '' : 'max-age=' + maxAge + '; ') + (expireTime == null ? '' : 'expires=' + expireTime + '; ') + 'path=' + path
}